import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Logo } from '../components/shell/Logo';

const Datenschutz: React.FC = () => {
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    fetch('/DATENSCHUTZ.md')
      .then(res => res.text())
      .then(text => setContent(text))
      .catch(err => {
        console.error('Error fetching DATENSCHUTZ.md:', err);
        setContent('# Datenschutzerklärung\nLeider konnte die Datei nicht geladen werden.');
      });
  }, []);

  return (
    <div className="min-h-screen bg-page">
      <header className="flex items-center justify-between border-b border-line px-4 py-3">
        <Logo />
        <Link
          to="/"
          className="text-sm text-brand underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-page"
        >
          Zur Startseite
        </Link>
      </header>
      <article className="mx-auto max-w-narrow px-4 py-8 prose dark:prose-invert">
        <ReactMarkdown>{content}</ReactMarkdown>
      </article>
    </div>
  );
};

export default Datenschutz;
